import { render, staticRenderFns } from "./PhysicianMapSimple.vue?vue&type=template&id=28f3b432"
import script from "./PhysicianMapSimple.vue?vue&type=script&lang=js"
export * from "./PhysicianMapSimple.vue?vue&type=script&lang=js"
import style0 from "./PhysicianMapSimple.vue?vue&type=style&index=0&id=28f3b432&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports